import API from '../helpers/api';
import { config } from '../helpers/constants';

const apiUrl = config.backendUrl + "api/";

export default class AuthService {

  static login(mail, pwd, resetCode) {
    const cmd = 'Login';

    return API.post(`${apiUrl + cmd}`, {
      mail,
      pwd,
      resetCode
    });
  }

  static registerUser(mail, pwd, licenseCode, regCode) {
    const cmd = 'RegisterUser';

    return API.post(`${apiUrl + cmd}`, {
      mail,
      pwd,
      licenseCode,
      regCode
    });
  }

  // for logout
  static logout() {
    const cmd = 'Logout';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  // for get sources api
  static getSources(reportid, permaLinkId = null) {
    const cmd = 'GetSources';
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      permaLinkId,
    });
  }

  static getCollusionSources(projectId = null, reportId = null, includeAll = false) {
    const cmd = 'GetCollusionSources';
    return API.post(`${apiUrl + cmd}`, {
      projectId,
      reportId,
      includeAll,
    });
  }

  // for get reports api
  static getReports(reportFilters) {
    const cmd = 'GetReports';
    //alert(JSON.stringify(reportFilters));
    return API.post(`${apiUrl + cmd}`, {
      ...reportFilters
    });
  }

  static getLicenseUsers(licenseUserFilters) {
    const cmd = 'GetLicenseUsers';
    return API.post(`${apiUrl + cmd}`, {
      ...licenseUserFilters
    });
  }

  static getLicenseUsageStatistics(licenseUserFilters, type, format) {
    const cmd = 'GetLicenseUsageStatistics';
    return API.post(`${apiUrl + cmd}`, {
      filters: licenseUserFilters,
      type: type,
      format: format
    });
  }

  static getLicenseUsageChartData(licenseUserFilters, type, format) {
    const cmd = 'GetLicenseUsageChartData';
    return API.post(`${apiUrl + cmd}`, {
      ...licenseUserFilters,
      type: type,
      format: format
    });
  }

  static createLicenseIntro() {
    const cmd = 'CreateLicenseIntro';
    return API.post(`${apiUrl + cmd}`, {
    });
  }


  static getLicenseAdmin() {
    const cmd = 'GetLicenseAdmin';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  static extendLicense() {
    const cmd = 'ExtendLicense';
    return API.post(`${apiUrl + cmd}`, {
    });
  }


  // for get reports api
  static getUploadForm(projectcode) {
    const cmd = 'GetUploadForm';
    return API.post(`${apiUrl + cmd}`, {
      projectcode
    });
  }

  // for get reports api
  static getLibraries(libraryFilters) {
    const cmd = 'GetLibraryTexts';
    return API.post(`${apiUrl + cmd}`, {
      ...libraryFilters
    });
  }

  // for get reports api
  static getMessages() {
    const cmd = 'GetUserMessages';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  static getNextMessage() {
    const cmd = 'GetNextMessage';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  static getSSOInfoFromMail(mail) {
    const cmd = 'GetSSOInfoFromMail';
    return API.post(`${apiUrl + cmd}`, {
      mail
    });
  }

  static getSSOInfo(ssoName) {
    const cmd = 'GetSSOInfo';
    return API.post(`${apiUrl + cmd}`, {
      ssoName
    });
  }


  // for get Report Markup api
  static getReportMarkup(reportid, permaLinkId = null) {
    const cmd = 'GetReportMarkup';
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      permaLinkId
    });
  }

  // for get Report api
  static getReport(reportid, fetchfulltext = false, permaLinkId = null) {
    const cmd = 'GetReport';
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      fetchfulltext,
      permaLinkId
    });
  }

  // for get Report api
  static getLibrary(libtextid, fetchfulltext) {
    const cmd = 'GetLibraryText';
    return API.post(`${apiUrl + cmd}`, {
      libtextid,
      fetchfulltext,
    });
  }

  // for get Report Status
  static getReportStatus(reportid, permaLinkId = null) {
    const cmd = 'GetReportStatus';
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      permaLinkId,
    });
  }

  // for update comments api
  static UpdateReports(data, reportids, permaLinkId) {
    const cmd = 'UpdateReports';
    const title = data.title || '';
    const date = data.date ? (data.date instanceof Date ? Math.floor(data.date.getTime() / 1000) : data.date) : Math.floor(Date.now() / 1000);
    const author = data.author || '';
    const projectid = data.projectid || '';
    const comment = data.comment || '';
    const field = data.field || '';
    return API.post(`${apiUrl + cmd}`, {
      reportids,
      permaLinkId,
      date,
      title,
      author,
      projectid,
      comment,
      field,
    });
  }

  static UpdateProject(projectData) {
    const cmd = 'UpdateProject';
    return API.post(`${apiUrl + cmd}`, {
      ...projectData
    });
  }

  static CreateProject(data) {
    const cmd = 'CreateProject';
    const name = data.name || '';
    const description = data.description || '';
    return API.post(`${apiUrl + cmd}`, {
      name,
      description,
    });
  }

  static UpdateLibraries(data, textids) {
    const cmd = 'UpdateLibraryTexts';
    const field = data.field || '';
    return API.post(`${apiUrl + cmd}`, {
      textids,
      ...data,
      field,
    });
  }

  // for post Update Ration api
  static updateSources(sources, reportid, permaLinkId) {
    const cmd = 'UpdateSources';

    return API.post(`${apiUrl + cmd}`, {
      sources,
      reportid,
      permaLinkId
    });
  }

  // for post Update Ration api
  static getSourceMarkup(sourceid, permaLinkId = null, settings = null) {
    const cmd = 'GetSourceMarkup';
    const payload = { sourceid, permaLinkId };
    if (settings) {
      payload.minRegionLength   = settings.minRegionLength;
      payload.maxPhraseDistance = settings.maxPhraseDistance;
      payload.minSimilarity     = settings.minSimilarity;
      payload.text1AsFingerprint = settings.text1AsFingerprint;
      payload.text2AsFingerprint = settings.text2AsFingerprint;
    }
    return API.post(`${apiUrl + cmd}`, payload);
  }

  // for get Project api
  static getProjects() {
    const cmd = 'GetProjects';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  // for reset report
  static resetReport(reportid, permaLinkId) {
    const cmd = 'ResetReport';
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      permaLinkId,
    });
  }

  static getTextOverlay(reportid, type, permaLinkId) {
    const cmd = 'GetTextOverlay';
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      type,
      permaLinkId,
    });
  }

  static getOverlayStatistics(reportid, permaLinkId) {
    const cmd = 'GetOverlayStatistics';
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      permaLinkId,
    });
  }


  // for get user info
  static getUserInfo() {
    const cmd = 'GetUserInfo';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

    // setBrowserId
    static setBrowserId(browserId) {
      const cmd = 'SetBrowserId';
      return API.post(`${apiUrl + cmd}`, {
        browserId
      });
    }
  

  // for get user info
  static revokeMandate(mandateId) {
    const cmd = 'RevokeMandate';
    return API.post(`${apiUrl + cmd}`, {
      mandateId
    });
  }

  // for calculate credits
  static calculateCredits(data) {
    const cmd = 'CalculateCredits';
    return API.post(`${apiUrl + cmd}`, {
      ...data
    });
  }

  static detectDocumentSections(text) {
    const cmd = 'DetectDocumentSections';
    return API.post(`${apiUrl + cmd}`, { text });
  }

  // for create check plagrsim
  static NewPlagCheck(data) {
    const cmd = 'NewPlagCheck';
    return API.post(`${apiUrl + cmd}`, {
      ...data,
    });
  }

  static AddTextsToLibrary(data) {
    const cmd = 'AddTextsToLibrary';
    return API.post(`${apiUrl + cmd}`, {
      ...data,
    });
  }

  static SyncLibraryTextsWithReports() {
    const cmd = 'SyncLibraryTextsWithReports';
    return API.post(`${apiUrl + cmd}`, {
    });
  }


  // for getting text from url in provide url tab
  static getUrlContents(data) {
    const cmd = 'GetUrlContents';
    const usetags = data.usetags;
    const url = data.url
    return API.post(`${apiUrl + cmd}`, {
      url,
      usetags,
    });
  }


  static getUploadedFilesStatus(uploadids) {
    const cmd = 'GetUploadedFilesStatus';
    return API.post(`${apiUrl + cmd}`, {
      uploadids,
    });
  }

  static getUploadedFileInfo(uploadid, fetchFulltext = false) {
    const cmd = 'GetUploadedFileInfo';
    return API.post(`${apiUrl + cmd}`, {
      uploadid,
      fetchFulltext
    });
  }



  static deleteReports(reportids) {
    const cmd = 'DeleteReports';
    return API.post(`${apiUrl + cmd}`, {
      reportids,
    });
  }

  static activateReports(reportids) {
    const cmd = 'ActivateReports';
    return API.post(`${apiUrl + cmd}`, {
      reportids,
    });
  }

  // for getting text from url in provide url tab
  static deleteProject(projectid) {
    const cmd = 'DeleteProject';
    return API.post(`${apiUrl + cmd}`, {
      projectid,
    });
  }

  // for getting text from url in provide url tab
  static deleteLibraries(libtextids) {
    const cmd = 'DeleteLibraryTexts';
    return API.post(`${apiUrl + cmd}`, {
      libtextids,
    });
  }

  static createOrder(product, currency, method, taxIncluded, taxMode, vatRate, uploadId) {
    const cmd = 'CreateOrder';
    const productid = product.id;
    const amount = product.cost[currency];
    return API.post(`${apiUrl + cmd}`, {
      productid,
      currency,
      taxIncluded,
      taxMode,
      vatRate,
      method,
      uploadId
    });
  }

  static createPayment(invoiceId, method) {
    const cmd = 'CreatePayment';
    return API.post(`${apiUrl + cmd}`, {
      invoiceId,
      method
    });
  }

  static updateLicense(license, attribs) {
    const cmd = 'UpdateLicense';
    return API.post(`${apiUrl + cmd}`, {
      license,
      ...attribs
    });
  }

  static updateUserQuota(userIds, quota) {
    const cmd = 'UpdatePerUserQuota';
    return API.post(`${apiUrl + cmd}`, {
      userIds,
      quota
    });
  }

  static verifyReCaptcha(token) {
    const cmd = 'VerifyReCaptcha';
    return API.post(`${apiUrl + cmd}`, {
      token
    });
  }

  static getProducts() {
    const cmd = 'GetProducts';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  static getCountries() {
    const cmd = 'GetCountries';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  // update user
  static updateInvoiceAddress(invoiceAddress) {
    const cmd = 'UpdateUser';
    return API.post(`${apiUrl + cmd}`, {
      ...invoiceAddress
    });
  }

  static updateUser(userData) {
    const cmd = 'UpdateUser';
    return API.post(`${apiUrl + cmd}`, {
      ...userData
    });
  }

  static updateUserAttrib(name, value) {
    const cmd = 'UpdateUserAttrib';
    return API.post(`${apiUrl + cmd}`, {
      attrib: name,
      value: value
    });
  }


  static removeUserLicense(userId) {
    const cmd = 'RemoveUserLicense';
    return API.post(`${apiUrl + cmd}`, {
      userId
    });
  }


  // update user settings
  static updateUserSettings(settings) {
    const cmd = 'UpdateUserSettings';
    return API.post(`${apiUrl + cmd}`, {
      ...settings
    });
  }

  // update user password
  static updateUserPassword(password) {
    const cmd = 'UpdateUserPassword';
    return API.post(`${apiUrl + cmd}`, {
      password
    });
  }

  // create user code 
  static createUserCode() {
    const cmd = 'CreateUserCode';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  static revokeUserCode() {
    const cmd = 'RevokeUserCode';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  // Delete User Account
  static deleteUser() {
    const cmd = 'DeleteUser';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  static getOrders() {
    const cmd = 'GetOrders';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  static cancelOrder(orderId) {
    const cmd = 'CancelOrder';
    return API.post(`${apiUrl + cmd}`, {
      orderId
    });
  }

  static requestRevocation(orderId, userId = null, captchaToken = null, email = null, name = null) {
    const cmd = 'RequestRevocation';
    return API.post(`${apiUrl + cmd}`, {
      orderId,
      userId,
      ...(captchaToken !== null && { captchaToken }),
      ...(email !== null && { email }),
      ...(name !== null && { name }),
    });
  }

  static getPaymentStatus(invoiceId) {
    const cmd = 'GetPaymentStatus';
    return API.post(`${apiUrl + cmd}`, {
      invoiceId
    });
  }

  static getInvoiceData(invoiceId) {
    const cmd = 'GetInvoiceData';
    return API.post(`${apiUrl + cmd}`, {
      invoiceId
    });
  }

  // for get news data api
  static loadNews(reportFilters) {
    const cmd = 'GetNews';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  // for get report chart data api
  static getChartData(mode) {
    const cmd = 'GetReportsStatistics';
    return API.post(`${apiUrl + cmd}`, {
      mode
    });
  }

  // Create guest user
  static createGuestUser() {
    const cmd = 'CreateGuestUser';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  // Send quote mail
  static sendQuoteMail(quote) {
    const cmd = 'SendQuoteMail';
    return API.post(`${apiUrl + cmd}`, {
      ...quote
    });
  }

  static sendContactMail(contactData) {
    const cmd = 'SendContactMail';
    return API.post(`${apiUrl + cmd}`, {
      ...contactData
    });
  }


  static sendPasswordResetMail(mail) {
    const cmd = 'SendPasswordResetMail';
    return API.post(`${apiUrl + cmd}`, {
      mail
    });
  }

  static setLanguage(lang) {
    const cmd = 'SetLanguage';
    return API.post(`${apiUrl + cmd}`, {
      lang,
    });
  }

  static createPdfReport({ permalinkid, reportFormat, reportLang, reportTruncate, reportRenderComments, reportIncludeGuide, includeAIDetection, includePlagReport }) {
    const cmd = 'CreatePdfReport';
    return API.post(`${apiUrl + cmd}`, {
      permalinkid,
      reportFormat,
      reportLang,
      reportTruncate,
      reportRenderComments,
      reportIncludeGuide,
      includeAIDetection,
      includePlagReport
    });
  }

  static createPdfReportStream({ permalinkid, reportFormat, reportLang, reportTruncate, reportRenderComments, reportIncludeGuide, includeAIDetection, includePlagReport, reportNameAsFilename }) {
    const cmd = 'CreatePdfReport';
    return API.postStream(`${apiUrl + cmd}`, {
      permalinkid,
      reportFormat,
      reportLang,
      reportTruncate,
      reportRenderComments,
      reportIncludeGuide,
      includeAIDetection,
      includePlagReport,
      reportNameAsFilename,
      stream: true
    });
  }

  static createSideBySidePDF(authsnapid, permaLinkId = null) {
    const cmd = 'CreateSideBySidePDF';
    return API.post(`${apiUrl + cmd}`, {
      authsnapid,
      permaLinkId
    });
  }

  static resolvePermaLink(permaLinkId, action) {
    const cmd = 'ResolvePermaLink';
    return API.post(`${apiUrl + cmd}`, {
      permaLinkId,
      action
    });
  }

  static createCollusionReport(projectId) {
    const cmd = 'GenerateCollusionReport';
    return API.post(`${apiUrl + cmd}`, {
      projectId
    });
  }

  static createTextComparison(uploadids) {
    const cmd = 'GenerateCollusionReport';
    return API.post(`${apiUrl + cmd}`, { uploadids });
  }

  static createComparisonFromLibtexts(libtextids) {
    const cmd = 'GenerateCollusionReport';
    return API.post(`${apiUrl + cmd}`, { libtextids });
  }

  static getTextComparisons() {
    const cmd = 'GetTextComparisons';
    return API.post(`${apiUrl + cmd}`, {});
  }

  static deleteTextComparison(reportId) {
    const cmd = 'DeleteTextComparison';
    return API.post(`${apiUrl + cmd}`, { reportid: reportId });
  }

  static getComparisonTexts(reportId) {
    const cmd = 'GetComparisonTexts';
    return API.post(`${apiUrl + cmd}`, { reportid: reportId });
  }

  static deleteComparisonText(reportId, token) {
    const cmd = 'DeleteComparisonText';
    return API.post(`${apiUrl + cmd}`, { reportid: reportId, token });
  }

  static addComparisonLibtext(reportId, libtextId) {
    const cmd = 'AddComparisonLibtext';
    return API.post(`${apiUrl + cmd}`, { reportid: reportId, libtextid: libtextId });
  }

  static addComparisonUploads(reportId, uploadids) {
    const cmd = 'AddComparisonUploads';
    return API.post(`${apiUrl + cmd}`, { reportid: reportId, uploadids });
  }

  static deleteCollusionReport(projectId) {
    const cmd = 'DeleteCollusionReport';
    return API.post(`${apiUrl + cmd}`, {
      projectId
    });
  }

  static returnToSession() {
    const cmd = 'ReturnToSession';
    return API.post(`${apiUrl + cmd}`, {
    });
  }

  static addUsers(userText, syncUsers, previewOnly) {
    const cmd = 'AddUsers';
    return API.post(`${apiUrl + cmd}`, {
      userText,
      syncUsers,
      previewOnly
    });
  }

  static removeUsersFromLicense(userText, previewOnly) {
    const cmd = 'RemoveUsersFromLicense';
    return API.post(`${apiUrl + cmd}`, {
      userText,
      previewOnly
    });
  }

  static uploadUserList(file) {
    const cmd = 'UploadUserList';
    const formData = new FormData();
    formData.append("file", file, file.name ); 

    return API.formPost(`${apiUrl + cmd}`, formData );
  }

  static loadFAQs() {
    const cmd = 'GetFAQs';
    return API.post(`${apiUrl + cmd}`, {
    });
  }


}
